import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';

import Constants from '../../config/constants';
import Form from '../form/Form';
import Map from '../map/Map';
import FieldGroup from '../field_group/FieldGroup';

import { searchProvinceByText } from '../../redux/provinces/province_actions';
import { listBuildingType } from '../../redux/building_type/building_type_actions';
import { getErrorValue } from '../../utils/utility';
import { requiredValidator } from '../field_group/validators';
import PaginateSelect from '../field_group/PaginateSelect';

export class ProjectDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;

    const { project } = this.props;
    this.state = project
      ? {
          location: {
            lat: parseFloat(project.latitude),
            lng: parseFloat(project.longitude),
          },
        }
      : {
          location: {
            lat: Constants.MAP_CENTER_LAT,
            lng: Constants.MAP_CENTER_LNG,
          },
        };
  }

  getProjectData() {
    return {
      ...this.formRef.getFormData(),
      ...this.state,
    };
  }

  componentDidMount() {
    this.props.listBuildingType();
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}`: item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  locationChangedHandler(name, value) {
    this.setState({
      location: {
        ...this.state.location,
        [name]: parseFloat(value),
      },
    });
  }

  markerMovedHandler(lat, lng) {
    this.setState({
        location: {
          lat: Number(lat.toFixed(6)),
          lng: Number(lng.toFixed(6)),
        },
      }, () => {
        this.formRef.onValueChange();
      });
  }

  render() {
    const {
      name,
      owner,
      designer,
      building_type_id,
      car_parking_area,
      roof_top_area,
      other_area_with_roof,
      height,
      building_cost,
      address,
      province_id,
      province_name,
      description,
      image,
    } = this.props.project || {};

    const {
      location: { lat, lng },
    } = this.state;

    const { disabled, fieldErrors, listProvince, t, ...otherAttr } = this.props;
    const customAttr = { disabled };

    const provinceOptions = province_id ? [
      { value: province_id, label: province_name },
    ] : [];

    const lang = this.props.i18n.language.split('-')[0];

    const isEditMode = !!this.props.project;
    const isMixedUse = isEditMode && this.props.project.is_mixed_use;
    return (
      <Form
        {...otherAttr}
        image={image}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
        ref={ref => (this.formRef = ref)}
      >
        <FieldGroup
          id="project-name"
          field="name"
          type="text"
          label={t('project name')}
          placeholder={t('project name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <Row>
          {(!isEditMode || !isMixedUse) &&
            <Col xs={12} md={6}>
              <FieldGroup
                id="project-building-type"
                field="building_type_id"
                componentClass="select"
                label={t('building type')}
                value={building_type_id}
                defaultDirty={true}
                errorMessage={getErrorValue(fieldErrors, 'building_type_id')}
                {...customAttr}
                disabled={!!(this.props.isProvinceLoading || disabled)}
              >
                {this.props.buildingTypes.map(type => this.renderOption(({...type, name: type[`name_${lang}`]}), 'bt'))}
              </FieldGroup>
            </Col>
          }
          {!isEditMode &&
            <Col xs={12} md={6}>
              <FieldGroup
                id="project-mixed-use"
                field="is_mixed_use"
                type="checkbox"
                defaultDirty={true}
                label={t('mixed-use building')}
                value={false}
                {...customAttr}
              />
            </Col>
          }
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-owner"
              field="owner"
              type="text"
              label={t('owner')}
              placeholder={t('owner')}
              value={owner}
              validators={[requiredValidator]}
              errorMessage={getErrorValue(fieldErrors, 'owner')}
              {...customAttr}
            />
          </Col>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-designer"
              field="designer"
              type="text"
              label={t('designer')}
              placeholder={t('designer')}
              value={designer}
              validators={[requiredValidator]}
              errorMessage={getErrorValue(fieldErrors, 'designer')}
              {...customAttr}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-car-park-area"
              type="number"
              field="car_park_area"
              label={`${t('car park area')} (${t('sq m')})`}
              value={car_parking_area || 0}
              defaultDirty={true}
              errorMessage={getErrorValue(fieldErrors, 'car_park_area')}
              {...customAttr}
            />
          </Col>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-roof-top-area"
              type="number"
              field="roof_top_area"
              label={`${t('roof top area')} (${t('sq m')})`}
              value={roof_top_area || 0}
              defaultDirty={true}
              errorMessage={getErrorValue(fieldErrors, 'roof_top_area')}
              {...customAttr}
            />
          </Col>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-other-area-with-roof"
              type="number"
              field="other_area_with_roof"
              label={`${t('other area with roof')} (${t('sq m')})`}
              value={other_area_with_roof || 0}
              defaultDirty={true}
              errorMessage={getErrorValue(fieldErrors, 'other_area_with_roof')}
              {...customAttr}
            />
          </Col>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-height"
              type="number"
              field="height"
              label={`${t('height')} (${t('meter abbrv')})`}
              value={height || 0}
              defaultDirty={true}
              errorMessage={getErrorValue(fieldErrors, 'height')}
              {...customAttr}
            />
          </Col>
        </Row>
        <FieldGroup
          id="project-building-cost"
          type="number"
          field="building_cost"
          label={t('building cost')}
          value={building_cost || 0}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'building_cost')}
          {...customAttr}
        />
        <FieldGroup
          id="project-address"
          field="address"
          componentClass="textarea"
          label={t('address')}
          value={address}
          errorMessage={getErrorValue(fieldErrors, 'address')}
          {...customAttr}
        />
        <FieldGroup
          id="project-province"
          componentClass={PaginateSelect.TYPE_NAME}
          field="province_id"
          label={t('province')}
          value={province_id}
          validators={[requiredValidator]}
          loadOptions={listProvince}
          options={provinceOptions}
        />
        <FieldGroup
          id="project-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          errorMessage={getErrorValue(fieldErrors, 'description')}
          {...customAttr}
        />
        <Row>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-latitude"
              type="number"
              label={t('latitude')}
              placeholder="100.2"
              value={lat}
              errorMessage={getErrorValue(fieldErrors, 'latitude')}
              onValueChange={value => this.locationChangedHandler('lat', value)}
              alwaysUpdate={true}
              {...customAttr}
            />
          </Col>
          <Col xs={12} md={6}>
            <FieldGroup
              id="project-longitude"
              type="number"
              label={t('longitude')}
              placeholder="13.1"
              value={lng}
              errorMessage={getErrorValue(fieldErrors, 'longitude')}
              onValueChange={value => this.locationChangedHandler('lng', value)}
              alwaysUpdate={true}
              {...customAttr}
            />
          </Col>
        </Row>
        <Map
          id="project-map"
          marker={{ name, lat, lng }}
          onMarkerMoved={(lat, lng) => this.markerMovedHandler(lat, lng)}
          editable
          forcedRedrawMarker
        />
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  provinces: state.province.orderedIds.map(id => state.province.provinces[id]),
  isProvinceLoading: state.province.loading,
  buildingTypes: state.buildingType.orderedIds.map(id => state.buildingType.buildingTypes[id]),
  isBuildingTypeLoading: state.buildingType.loading,
  errorMessage: state.province.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  listProvince: (searchValue, page) => {
    return searchProvinceByText(searchValue, page)
      .then(response => response.data.map(province => ({value: province.id, label: province.name})))
      .catch(() => {});
  },
  listBuildingType: () => dispatch(listBuildingType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ProjectDetail),
);



// WEBPACK FOOTER //
// ./src/components/project_detail/ProjectDetail.js